var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTiktok = function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 42"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.643 41.928c11.676 0 21.142-9.178 21.142-20.5S33.32.928 21.643.928.5 10.106.5 21.428s9.466 20.5 21.143 20.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF460F",
    stroke: "#000",
    strokeWidth: 2,
    d: "M17.495 20.538a4.86 4.86 0 0 0-4.225 4.814 4.86 4.86 0 0 0 4.866 4.855A4.86 4.86 0 0 0 23 25.352V14.08l1.836 2.806a4.16 4.16 0 0 0 2.942 1.84v-1.34a6.16 6.16 0 0 1-4.575-4.449h-.933l-.027 12.45v.002l-1-.003c0 1.653-1.453 2.953-3.108 2.953a2.989 2.989 0 0 1-.467-5.941zm0 0v.876z"
  })));
};
export default SvgTiktok;